const PAGINATOR_INFO = {
  count: true,
  currentPage: true,
  firstItem: true,
  hasMorePages: true,
  lastItem: true,
  lastPage: true,
  perPage: true,
  total: true,
};

const DEFAULT_REDUCER = (x) => x.id;
const DEFAULT_LABEL = (x) => x.name_ar;

export default {
  ngos: {
    title: "المنظمات",
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "name_ar",
      },
      {
        label: "الشكل القانوني",
        key: "legalForm.name_ar",
      },
      {
        label: "الحالة",
        key: "status.name_ar",
      },
      {
        label: "رقم قرار الإشهار",
        key: "decision_no",
      },
      {
        label: "تاريخ قرار الإشهار",
        key: "decision_date",
      },
    ],
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المنظمات",
        active: true,
      },
    ],
    filtersObject: {
      "ngos.name_ar": {
        component: "FormInput",
        key: "ngos.name_ar",
        attrs: { id: "1695638448610", label: "الاسم " },
      },
      "ngos.decision_no": {
        component: "FormInput",
        key: "ngos.decision_no",
        attrs: {
          id: "1695638448610",
          label: "رقم قرار الإشهار ",
        },
      },
      "ngos.decision_date": {
        component: "FormMultiDatepicker",
        key: "ngos.decision_date",
        attrs: { id: "1695638448610", label: "تاريخ قرار الإشهار " },
      },
      "ngos.status.ids": {
        component: "FormSelect",
        key: "ngos.status.ids",
        attrs: {
          id: "ngos.status.ids",
          ep: "v2/ministry/selects/graphql/ngo-status",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (الحالة)",
        },
      },
      "ngos.legalForm.ids": {
        component: "FormSelect",
        key: "ngos.legalForm.ids",
        attrs: {
          id: "ngos.legalForm.ids",
          ep: "v2/ministry/selects/graphql/legal-forms",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (الشكل القانوني)",
        },
      },
    },
    queryObject: {
      query: {
        ngos: {
          data: {
            id: true,
            name_ar: true,
            status: {
              name_ar: true,
            },
            legalForm: {
              name_ar: true,
            },
            decision_no: true,
            decision_date: true,
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
  },

  classifications: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formSelect",
        filterMeta: {
          id: "classifications",
          ep: "v2/ministry/selects/reports/classifications",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
        key: "r_ngo_classification",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: false,
      },
    ],
    title: "تصنيفات المنظمات",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "تصنيفات المنظمات",
        active: true,
      },
    ],
  },
  branches: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "العنوان",
        key: "address",
      },
      {
        label: "رقم العقار",
        key: "realEstate.number",
      },
      {
        label: "نوع العقار",
        key: "branchType.name_ar",
      },
      {
        label: "المحافظة",
        key: "governorate.name_ar",
      },
      {
        label: "منطقة العقار",
        key: "subDistrict.name_ar",
      },
      {
        label: "المنظمة",

        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "branches.address": {
        component: "FormInput",
        key: "branches.address",
        attrs: { id: "1695734947642", label: "العنوان " },
      },
      "branches.ngo.ids": {
        component: "FormSelect",
        key: "branches.ngo.ids",
        attrs: {
          id: "branches.ngo.ids",

          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
      "branches.subDistrict.ids": {
        component: "FormSelect",
        key: "branches.subDistrict.ids",
        attrs: {
          id: "branches.subDistrict.ids",

          ep: "v2/ministry/selects/graphql/areas",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المنظقة)",
        },
      },
      "branches.branchType.ids": {
        component: "FormSelect",
        key: "branches.branchType.ids",
        attrs: {
          id: "branches.branchType.ids",
          ep: "v2/ministry/selects/graphql/branch-types",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (نوع الفرع)",
        },
      },
      "branches.realEstate.ids": {
        component: "FormSelect",
        key: "branches.realEstate.ids",
        attrs: {
          id: "branches.realEstate.ids",
          ep: "v2/ministry/selects/graphql/real-estates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.number,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (realEstate)",
        },
      },
      "branches.governorate.ids": {
        component: "FormSelect",
        key: "branches.governorate.ids",
        attrs: {
          id: "branches.governorate.ids",
          ep: "v2/ministry/selects/graphql/governorates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المحافظة)",
        },
      },
    },
    queryObject: {
      query: {
        branches: {
          data: {
            id: true,
            address: true,
            headquarters_type: true,
            ngo: { name_ar: true },
            subDistrict: { name_ar: true },
            branchType: { name_ar: true },
            realEstate: { number: true },
            governorate: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "الفروع",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الفروع",
        active: true,
      },
    ],
  },
  serviceCentres: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "العنوان",
        key: "address",
      },
      {
        label: "المنطقة",
        key: "area.name_ar",
      },
      {
        label: "رقم العقار",
        key: "realEstate.number",
      },
      {
        label: "نوع المركز",
        key: "serviceCentreType.name",
      },

      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "serviceCentres.address": {
        component: "FormInput",
        key: "serviceCentres.address",
        attrs: { label: "العنوان " },
      },
      "serviceCentres.realEstate.ids": {
        component: "FormSelect",
        key: "serviceCentres.realEstate.ids",
        attrs: {
          id: "serviceCentres.realEstate.ids",
          ep: "v2/ministry/selects/graphql/real-estates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.number,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (العقار)",
        },
      },
      "serviceCentres.serviceCentreType.ids": {
        component: "FormSelect",
        key: "serviceCentres.serviceCentreType.ids",
        attrs: {
          id: "serviceCentres.serviceCentreType.ids",

          ep: "v2/ministry/selects/graphql/service-centre-types",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.name,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (نوع المركز الخدمي)",
        },
      },
      "serviceCentres.ngo.ids": {
        component: "FormSelect",
        key: "serviceCentres.ngo.ids",
        attrs: {
          id: "serviceCentres.ngo.ids",

          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المنظمة)",
        },
      },
      "serviceCentres.areas.ids": {
        component: "FormSelect",
        key: "serviceCentres.areas.ids",
        attrs: {
          id: "serviceCentres.areas.ids",

          ep: "v2/ministry/selects/graphql/areas",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المنطقة)",
        },
      },
    },
    queryObject: {
      query: {
        serviceCentres: {
          data: {
            id: true,
            name: true,
            serviceCentreType: { name: true },
            address: true,
            ngo: { name_ar: true },
            realEstate: { number: true },
            area: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "المراكز الخدمية",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المراكز الخدمية",
        active: true,
      },
    ],
  },
  services: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formSelect",
        filterMeta: {
          id: "services-select",
          ep: "v2/ministry/selects/reports/services",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
        key: "r_service",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "الخدمات",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الخدمات",
        active: true,
      },
    ],
  },
  "service-centres": {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      { label: "الاسم", filterType: "formInput", key: "name", sortable: true },
      {
        label: "رقم قرار الترخيص",
        key: "clearance_decision_number",
      },
      {
        label: "الجهة المرخصة",
        key: "r_clearance_authority",
        filterType: "formSelect",
        filterMeta: {
          id: "clearance-authority",
          ep: "v2/ministry/selects/reports/clearance-authorities",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name,
          multiple: true,
          closeOnSelect: false,
        },
      },
      {
        label: "رقم العقار",
        filterType: "formSelect",
        filterMeta: {
          id: "estate-no",
          ep: "v2/ministry/selects/reports/real-estates",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.number,
          multiple: true,
          closeOnSelect: false,
        },
        key: "r_real_estate",
      },
      {
        label: "نوع المركز",
        filterType: "formSelect",
        filterMeta: {
          id: "centre-type",
          ep: "v2/ministry/selects/reports/service-centre-types",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name,
          multiple: true,
          closeOnSelect: false,
        },
        key: "r_service_centre_type",
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "المراكز الخدمية",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المراكز الخدمية",
        active: true,
      },
    ],
  },
  contacts: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "النوع",
        key: "r_type",
        filterType: "formSelect",
        filterMeta: {
          id: "types",
          ep: "v2/ministry/selects/reports/types",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
        sortable: true,
      },
      { label: "القيمة", key: "value", sortable: true },
    ],
    title: "معلومات التواصل",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "معلومات التواصل",
        active: true,
      },
    ],
  },
  serviceCentres: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "العنوان",
        key: "address",
      },
      {
        label: "المنطقة",
        key: "area.name_ar",
      },
      {
        label: "رقم العقار",
        key: "realEstate.number",
      },
      {
        label: "نوع المركز",
        key: "serviceCentreType.name",
      },

      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "serviceCentres.address": {
        component: "FormInput",
        key: "serviceCentres.address",
        attrs: { label: "العنوان " },
      },
      "serviceCentres.realEstate.ids": {
        component: "FormSelect",
        key: "serviceCentres.realEstate.ids",
        attrs: {
          id: "serviceCentres.realEstate.ids",
          ep: "v2/ministry/selects/graphql/real-estates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.number,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (العقار)",
        },
      },
      "serviceCentres.serviceCentreType.ids": {
        component: "FormSelect",
        key: "serviceCentres.serviceCentreType.ids",
        attrs: {
          id: "serviceCentres.serviceCentreType.ids",

          ep: "v2/ministry/selects/graphql/service-centre-types",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.name,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (نوع المركز الخدمي)",
        },
      },
      "serviceCentres.ngo.ids": {
        component: "FormSelect",
        key: "serviceCentres.ngo.ids",
        attrs: {
          id: "serviceCentres.ngo.ids",

          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المنظمة)",
        },
      },
      "serviceCentres.areas.ids": {
        component: "FormSelect",
        key: "serviceCentres.areas.ids",
        attrs: {
          id: "serviceCentres.areas.ids",

          ep: "v2/ministry/selects/graphql/areas",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المنطقة)",
        },
      },
    },
    queryObject: {
      query: {
        serviceCentres: {
          data: {
            id: true,
            name: true,
            serviceCentreType: { name: true },
            address: true,
            ngo: { name_ar: true },
            realEstate: { number: true },
            area: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "المراكز الخدمية",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المراكز الخدمية",
        active: true,
      },
    ],
  },
  bankAccounts: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "اسم البنك",
        key: "bank.name_ar",
      },
      {
        label: "اسم الفرع",
        key: "branch_name",
      },
      {
        label: "رقم الحساب",
        key: "account_no",
      },
      {
        label: "متاح للتبرع",
        key: "is_available",
        formatter: (val) => (val === true ? "نعم" : "لا"),
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "bankAccounts.branch_name": {
        component: "FormInput",
        key: "bankAccounts.branch_name",
        attrs: { label: "اسم الفرع " },
      },
      "bankAccounts.account_no": {
        component: "FormInput",
        key: "bankAccounts.account_no",
        attrs: { label: "رقم الحساب " },
      },
      "bankAccounts.is_available": {
        component: "FormSelect",
        key: "bankAccounts.is_available",
        attrs: {
          id: "bankAccounts.is_available",
          options: [
            { text: "نعم", value: true },
            { text: "لا", value: false },
          ],
          reduce: (x) => x.value,
          getOptionLabel: (x) => x.text,
          label: "متاح للتبرع ",
        },
      },
      "bankAccounts.bank.ids": {
        component: "FormSelect",
        key: "bankAccounts.bank.ids",
        attrs: {
          id: "bankAccounts.bank.ids",

          ep: "v2/ministry/selects/graphql/banks",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (اسم البنك)",
        },
      },
      "bankAccounts.ngo.ids": {
        component: "FormSelect",
        key: "bankAccounts.ngo.ids",
        attrs: {
          id: "bankAccounts.ngo.ids",

          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        bankAccounts: {
          data: {
            id: true,
            branch_name: true,
            account_no: true,
            is_available: true,
            bank: {
              name_ar: true,
            },
            ngo: {
              name_ar: true,
            },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "الحسابات البنكية",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الحسابات البنكية",
        active: true,
      },
    ],
  },
  accountManagers: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم الكامل",
        key: "full_name",
      },
      {
        label: "الرقم الوطني",
        key: "id_number",
      },
      {
        label: "اسم البنك",
        key: "bankAccount.branch_name",
      },
      {
        label: "تاريخ التعيين",
        key: "assign_date",
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "accountManagers.full_name": {
        component: "FormInput",
        key: "accountManagers.full_name",
        attrs: {
          label: "الاسم الكامل ",
        },
      },
      "accountManagers.id_number": {
        component: "FormInput",
        key: "accountManagers.id_number",
        attrs: {
          label: "الرقم الوطني ",
        },
      },
      "accountManagers.assign_date": {
        component: "FormMultiDatepicker",
        key: "accountManagers.assign_date",
        attrs: { label: "تاريخ التعيين " },
      },
      "accountManagers.bankAccount.ids": {
        component: "FormSelect",
        key: "accountManagers.bankAccount.ids",
        attrs: {
          id: "accountManagers.bankAccount.ids",
          ep: "v2/ministry/selects/graphql/bank-accounts",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.branch_name,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (الحساب البنكي)",
        },
      },
      "accountManagers.ngo.ids": {
        component: "FormSelect",
        key: "accountManagers.ngo.ids",
        attrs: {
          id: "accountManagers.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        accountManagers: {
          data: {
            id: true,
            full_name: true,
            id_number: true,
            assign_date: true,
            bankAccount: {
              branch_name: true,
            },
            ngo: {
              name_ar: true,
            },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "محركي الحسابات",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "محركي الحسابات",
        active: true,
      },
    ],
  },
  // TODO : NOT FINISHED YET
  events: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "العنوان",
        key: "title_ar",
      },
      {
        label: "نوع الدعوة",
        key: "invitation_type",
        formatter: (val) => (val === false ? "عامة" : "خاصة"),
      },
      {
        label: "المحافظة",
        key: "r_governorate",
      },
      {
        label: "نوع الفعالية",
        key: "r_event_type",
      },

      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],

    filtersObject: {
      "accountManagers.full_name": {
        component: "FormInput",
        key: "accountManagers.full_name",
        attrs: {
          label: "الاسم الكامل ",
        },
      },
      "accountManagers.id_number": {
        component: "FormInput",
        key: "accountManagers.id_number",
        attrs: {
          label: "الرقم الوطني ",
        },
      },
      "accountManagers.assign_date": {
        component: "FormMultiDatepicker",
        key: "accountManagers.assign_date",
        attrs: { label: "تاريخ التعيين " },
      },
      "accountManagers.bankAccount.ids": {
        component: "FormSelect",
        key: "accountManagers.bankAccount.ids",
        attrs: {
          id: "accountManagers.bankAccount.ids",
          ep: "v2/ministry/selects/graphql/bank-accounts",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: (x) => x.branch_name,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (الحساب البنكي)",
        },
      },
      "accountManagers.ngo.ids": {
        component: "FormSelect",
        key: "accountManagers.ngo.ids",
        attrs: {
          id: "accountManagers.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        accountManagers: {
          data: {
            id: true,
            full_name: true,
            id_number: true,
            assign_date: true,
            bankAccount: {
              branch_name: true,
            },
            ngo: {
              name_ar: true,
            },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: " الفعاليات ",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: " الفعاليات ",
        active: true,
      },
    ],
  },

  realEstates: {
    title: "العقارات",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "العقارات",
        active: true,
      },
    ],
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "رقم العقار",
        key: "number",
      },
      {
        label: "المنطقة",
        key: "region",
      },
      {
        label: "المحافظة",
        key: "governorate.name_ar",
      },
      {
        label: "الشكل القانوني",
        key: "possessiveForm.name_ar",
      },

      {
        label: "نوع العقار",
        key: "estateType.name_ar",
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],

    filtersObject: {
      "realEstates.number": {
        component: "FormInput",
        key: "realEstates.number",
        attrs: { label: "رقم العقار " },
      },
      "realEstates.region": {
        component: "FormInput",
        key: "realEstates.region",
        attrs: { label: "المنطقة " },
      },
      "realEstates.estateType.ids": {
        component: "FormSelect",
        key: "realEstates.estateType.ids",
        attrs: {
          id: "realEstates.estateType.ids",

          ep: "v2/ministry/selects/graphql/estate-types",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (نوع العقار)",
        },
      },
      "realEstates.governorate.ids": {
        component: "FormSelect",
        key: "realEstates.governorate.ids",
        attrs: {
          id: "realEstates.governorate.ids",

          ep: "v2/ministry/selects/graphql/governorates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المحافظة)",
        },
      },
      "realEstates.possessiveForm.ids": {
        component: "FormSelect",
        key: "realEstates.possessiveForm.ids",
        attrs: {
          id: "realEstates.possessiveForm.ids",

          ep: "v2/ministry/selects/graphql/possessive-forms",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (صيغة التملك)",
        },
      },
      "realEstates.ngo.ids": {
        component: "FormSelect",
        key: "realEstates.ngo.ids",
        attrs: {
          id: "realEstates.ngo.ids",

          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },

    queryObject: {
      query: {
        realEstates: {
          data: {
            id: true,
            number: true,
            region: true,
            estateType: { name_ar: true },
            governorate: { name_ar: true },
            possessiveForm: { name_ar: true },
            ngo: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
  },

  machines: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الطراز",
        key: "model",
      },
      {
        label: "رقم اللوحة",
        key: "plate_number",
      },
      {
        label: "الرقم التسلسلي",
        key: "serial_number",
      },
      {
        label: "رقم الهيكل",
        key: "structure_no",
      },
      {
        label: "نوع الوقود",
        key: "fuel_type",
      },
      {
        label: "عدد الركاب",
        key: "passengers_number",
      },
      {
        label: "سنة الصنع",
        key: "year",
      },
      {
        label: "معفاة من الضريبة",
        key: "tax",
      },
      {
        label: "المحافظة",
        key: "governorate.name_ar",
      },
      {
        label: "نوع الآلية",
        key: "machineType.name_ar",
      },
      {
        label: "صيغة التملك",
        key: "possessiveForm.name_ar",
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    title: "الآليات",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الآليات",
        active: true,
      },
    ],
    queryObject: {
      query: {
        machines: {
          data: {
            id: true,
            model: true,
            plate_number: true,
            serial_number: true,
            structure_no: true,
            fuel_type: true,
            passengers_number: true,
            year: true,
            tax: true,
            machineType: { name_ar: true },
            governorate: { name_ar: true },
            possessiveForm: { name_ar: true },
            ngo: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    filtersObject: {
      "machines.model": {
        component: "FormInput",
        key: "machines.model",
        attrs: { label: "الطراز " },
      },
      "machines.plate_number": {
        component: "FormInput",
        key: "machines.plate_number",
        attrs: { label: "رقم اللوحة " },
      },
      "machines.serial_number": {
        component: "FormInput",
        key: "machines.serial_number",
        attrs: {
          label: "الرقم التسلسلي ",
        },
      },
      "machines.structure_no": {
        component: "FormInput",
        key: "machines.structure_no",
        attrs: { label: "رقم الهيكل " },
      },
      "machines.fuel_type": {
        component: "FormInput",
        key: "machines.fuel_type",
        attrs: { label: "نوع الوقود " },
      },
      "machines.passengers_number": {
        component: "FormInput",
        key: "machines.passengers_number",
        attrs: { label: "عدد الركاب " },
      },
      "machines.year": {
        component: "FormInput",
        key: "machines.year",
        attrs: { label: "السنة " },
      },
      "machines.tax": {
        component: "FormSelect",
        key: "machines.tax",
        attrs: {
          id: "machines.tax",
          options: [
            { text: "نعم", value: true },
            { text: "لا", value: false },
          ],
          reduce: (x) => x.value,
          getOptionLabel: (x) => x.text,
          label: "تملك الضريبة؟ ",
        },
      },
      "machines.machineType.ids": {
        component: "FormSelect",
        key: "machines.machineType.ids",
        attrs: {
          id: "machines.machineType.ids",
          ep: "v2/ministry/selects/graphql/machine-types",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (نوع الآلية)",
        },
      },
      "machines.governorate.ids": {
        component: "FormSelect",
        key: "machines.governorate.ids",
        attrs: {
          id: "machines.governorate.ids",
          ep: "v2/ministry/selects/graphql/governorates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المحافظة)",
        },
      },
      "machines.possessiveForm.ids": {
        component: "FormSelect",
        key: "machines.possessiveForm.ids",
        attrs: {
          id: "machines.possessiveForm.ids",
          ep: "v2/ministry/selects/graphql/possessive-forms",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (صيغة التملك)",
        },
      },
      "machines.ngo.ids": {
        component: "FormSelect",
        key: "machines.ngo.ids",
        attrs: {
          id: "machines.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
  },

  programs: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "name",
      },
      {
        label: "الأهداف",
        key: "objectives",
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "programs.name": {
        component: "FormInput",
        key: "programs.name",
        attrs: { label: "الاسم" },
      },
      "programs.objectives": {
        component: "FormInput",
        key: "programs.objectives",
        attrs: { label: "الأهداف" },
      },
      "programs.ngo.ids": {
        component: "FormSelect",
        key: "programs.ngo.ids",
        attrs: {
          id: "programs.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        programs: {
          data: {
            id: true,
            name: true,
            objectives: true,
            ngo: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "البرامج",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "البرامج",
        active: true,
      },
    ],
  },

  activities: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "name",
      },
      {
        label: "نوع النشاط",
        key: "activity_type",
        formatter: (val) => (val === 0 ? "مرتبط بالخطة" : "طارئ"),
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "activities.name": {
        component: "FormInput",
        key: "activities.name",
        attrs: { label: "الاسم" },
      },
      "activities.objectives": {
        component: "FormInput",
        key: "activities.objectives",
        attrs: { label: "الأهداف" },
      },

      "activities.activity_type": {
        component: "FormSelect",
        key: "activities.activity_type",
        attrs: {
          id: "activities.activity_type",
          reduce: (x) => x.value,
          getOptionLabel: (x) => x.text,
          options: [
            { text: "مرتبط بخطة", value: 0 },
            { text: "طارئ", value: 1 },
          ],
          label: "نوع النشاط ",
        },
      },
      "activities.ngo.ids": {
        component: "FormSelect",
        key: "activities.ngo.ids",
        attrs: {
          id: "activities.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        activities: {
          data: {
            id: true,
            name: true,
            activity_type: true,
            ngo: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "الأنشطة",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الأنشطة",
        active: true,
      },
    ],
  },

  plans: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "المنظمة",
        key: "r_ngo",
        sortable: true,
        filterType: "formSelect",
        filterMeta: {
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
      },
      { label: "السنة", key: "year", sortable: true, filterType: "formInput" },
      {
        label: "الحالة",
        key: "status",
        sortable: true,
        filterType: "formInput",
      },
    ],
    title: "الخطط السنوية",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الخطط السنوية",
        active: true,
      },
    ],
  },

  campaigns: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "name_ar",
      },
      {
        label: "نوع الحملة",
        key: "campaign_type",
        formatter: (val) => (val ? "مادية" : "عينية"),
      },
      {
        label: "تاريخ البداية",
        key: "start_date",
      },
      {
        label: "تاريخ النهاية",
        key: "end_date",
      },
      {
        label: "المحافظة",
        key: "governorate.name_ar",
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "campaigns.name_ar": {
        component: "FormInput",
        key: "campaigns.name_ar",
        attrs: { label: "الاسم " },
      },
      "campaigns.campaign_type": {
        component: "FormSelect",
        key: "campaigns.campaign_type",
        attrs: {
          options: [
            { text: "مادية", value: true },
            { text: "عينية", value: false },
          ],
          reduce: (x) => x.value,
          getOptionLabel: (x) => x.text,
          label: "نوع الحملة ",
        },
      },
      "campaigns.start_date": {
        component: "FormMultiDatepicker",
        key: "campaigns.start_date",
        attrs: { label: "تاريخ البداية " },
      },
      "campaigns.end_date": {
        component: "FormMultiDatepicker",
        key: "campaigns.end_date",
        attrs: { label: "تاريخ النهاية " },
      },
      "campaigns.ngo.ids": {
        component: "FormSelect",
        key: "campaigns.ngo.ids",
        attrs: {
          id: "campaigns.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
      "campaigns.governorate.ids": {
        component: "FormSelect",
        key: "campaigns.governorate.ids",
        attrs: {
          id: "campaigns.governorate.ids",
          ep: "v2/ministry/selects/graphql/governorates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المحافظة)",
        },
      },
    },

    queryObject: {
      query: {
        campaigns: {
          data: {
            id: true,
            name_ar: true,
            campaign_type: true,
            start_date: true,
            end_date: true,
            ngo: { name_ar: true },
            governorate: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "حملات التبرع",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "حملات التبرع",
        active: true,
      },
    ],
  },

  events: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "العنوان",
        filterType: "formInput",
        key: "title_ar",
        sortable: true,
      },
      {
        label: "نوع الدعوة",
        key: "invitation_type",
        sortable: true,
        formatter: (val) => (val === 0 ? "عامة" : "خاصة"),
      },
      {
        label: "المحافظة",
        filterType: "formInput",
        key: "r_governorate",
        filterType: "formSelect",
        filterMeta: {
          id: "governorates",
          ep: "v2/ministry/selects/reports/governorates",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
        sortable: true,
      },
      {
        label: "نوع الفعالية",
        key: "r_event_type",
        sortable: true,
        filterType: "formSelect",
        filterMeta: {
          id: "event-types",
          ep: "v2/ministry/selects/reports/event-types",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          multiple: true,
          closeOnSelect: false,
        },
      },

      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: " الفعاليات ",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: " الفعاليات ",
        active: true,
      },
    ],
  },

  volunteers: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formInput",
        key: "first_name",
        sortable: true,
      },
      {
        label: "الكنية",
        filterType: "formInput",
        key: "last_name",
        sortable: true,
      },
      {
        label: "الرقم الوطني",
        filterType: "formInput",
        key: "id_number",
        sortable: true,
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
        filterType: "formInput",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "المتطوعين",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المتطوعين",
        active: true,
      },
    ],
  },

  administrators: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formInput",
        key: "first_name",
        sortable: true,
      },
      {
        label: "الكنية",
        filterType: "formInput",
        key: "last_name",
        sortable: true,
      },
      {
        label: "الرقم الوطني",
        filterType: "formInput",
        key: "id_number",
        sortable: true,
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
        filterType: "formInput",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "مجلس الإدارة",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "مجلس الإدارة",
        active: true,
      },
    ],
  },

  founders: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formInput",
        key: "first_name",
        sortable: true,
      },
      {
        label: "الكنية",
        filterType: "formInput",
        key: "last_name",
        sortable: true,
      },
      {
        label: "الرقم الوطني",
        filterType: "formInput",
        key: "id_number",
        sortable: true,
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
        filterType: "formInput",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "مجلس التأسيس",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "مجلس التأسيس",
        active: true,
      },
    ],
  },

  trustees: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formInput",
        key: "first_name",
        sortable: true,
      },
      {
        label: "الكنية",
        filterType: "formInput",
        key: "last_name",
        sortable: true,
      },
      {
        label: "الرقم الوطني",
        filterType: "formInput",
        key: "id_number",
        sortable: true,
      },
      {
        label: "المسمى الوظيفي",
        filterType: "formInput",
        key: "position",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "مجلس الأمناء",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "مجلس الأمناء",
        active: true,
      },
    ],
  },
  employees: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "first_name",
      },
      {
        label: "الكنية",
        key: "last_name",
      },
      {
        label: "الرقم الوطني",
        key: "id_number",
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
      },
      {
        label: "المنظمة",
        key: "branch.ngo.name_ar",
      },
    ],
    filtersObject: {
      "employees.first_name": {
        component: "FormInput",
        key: "employees.first_name",
        attrs: { label: "الاسم" },
      },
      "employees.last_name": {
        component: "FormInput",
        key: "employees.last_name",
        attrs: { label: "الكنية" },
      },
      "employees.id_number": {
        component: "FormInput",
        key: "employees.id_number",
        attrs: { label: "الرقم الوطني" },
      },
      "employees.position": {
        component: "FormInput",
        key: "employees.position",
        attrs: { label: "مجال العمل" },
      },
      "employees.branch.ngo.ids": {
        component: "FormSelect",
        key: "employees.branch.ngo.ids",
        attrs: {
          id: "employees.branch.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        employees: {
          data: {
            id: true,
            first_name: true,
            last_name: true,
            id_number: true,
            position: true,
            branch: { ngo: { name_ar: true } },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "الموظفين",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الموظفين",
        active: true,
      },
    ],
  },
  volunteers: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "first_name",
      },
      {
        label: "الكنية",
        key: "last_name",
      },
      {
        label: "الرقم الوطني",
        key: "id_number",
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
      },
      {
        label: "المنظمة",
        key: "branch.ngo.name_ar",
      },
    ],
    filtersObject: {
      "volunteers.first_name": {
        component: "FormInput",
        key: "volunteers.first_name",
        attrs: { label: "الاسم" },
      },
      "volunteers.last_name": {
        component: "FormInput",
        key: "volunteers.last_name",
        attrs: { label: "الكنية" },
      },
      "volunteers.id_number": {
        component: "FormInput",
        key: "volunteers.id_number",
        attrs: { label: "الرقم الوطني" },
      },
      "volunteers.position": {
        component: "FormInput",
        key: "volunteers.position",
        attrs: { label: "مجال العمل" },
      },
      "volunteers.branch.ngo.ids": {
        component: "FormSelect",
        key: "volunteers.branch.ngo.ids",
        attrs: {
          id: "volunteers.branch.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        volunteers: {
          data: {
            id: true,
            first_name: true,
            last_name: true,
            id_number: true,
            position: true,
            branch: { ngo: { name_ar: true } },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "المتطوعين",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المتطوعين",
        active: true,
      },
    ],
  },
  executives: {
    fields: [
      {
        label: "المعرف",
        key: "id",
        filterType: "formInput",
        numberModel: true,
        sortable: true,
      },
      {
        label: "الاسم",
        filterType: "formInput",
        key: "first_name",
        sortable: true,
      },
      {
        label: "الكنية",
        filterType: "formInput",
        key: "last_name",
        sortable: true,
      },
      {
        label: "الرقم الوطني",
        filterType: "formInput",
        key: "id_number",
        sortable: true,
      },
      {
        label: "المسمى الوظيفي",
        key: "position",
        filterType: "formInput",
        sortable: true,
      },
      {
        label: "المنظمة",
        filterType: "formAutocomplete",
        filterMeta: {
          placeholder: "ابدأ بالكتابة للبحث ...",
          id: "ngos",
          ep: "v2/ministry/selects/reports/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
        },
        key: "r_ngo",
        sortable: true,
      },
    ],
    title: "المجلس التنفيذي",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "المجلس التنفيذي",
        active: true,
      },
    ],
  },

  opportunities: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "الاسم",
        key: "name",
      },

      {
        label: "الرمز",
        key: "code",
      },
      {
        label: "عدد الشواغر",
        key: "vacancies_number",
      },
      {
        label: "نوع الفرصة",
        key: "type",
        formatter: (val) => (val === "job" ? "فرصة عمل" : "فرصة تطوع"),
      },
      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    filtersObject: {
      "opportunities.name": {
        component: "FormInput",
        key: "opportunities.name",
        attrs: { label: "الاسم" },
      },
      "opportunities.code": {
        component: "FormInput",
        key: "opportunities.code",
        attrs: { label: "الرمز" },
      },
      "opportunities.vacancies_number": {
        component: "FormInput",
        key: "opportunities.vacancies_number",
        attrs: { label: "عدد الشواغر" },
      },
      "opportunities.type": {
        component: "FormSelect",
        key: "opportunities.type",
        attrs: {
          id: "opportunities.type",
          options: [
            { text: "عمل", value: "job" },
            { text: "تطوع", value: "volunteer" },
          ],
          reduce: (x) => x.value,
          getOptionLabel: (x) => x.text,
          label: "نوع الفرصة ",
        },
      },
      "opportunities.ngo.ids": {
        component: "FormSelect",
        key: "opportunities.ngo.ids",
        attrs: {
          id: "opportunities.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    queryObject: {
      query: {
        opportunities: {
          data: {
            id: true,
            name: true,
            type: true,
            vacancies_number: true,
            code: true,
            ngo: { name_ar: true },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    title: "الفرص",
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "الفرص",
        active: true,
      },
    ],
  },

  news: {
    fields: [
      {
        label: "المعرف",
        key: "id",
      },
      {
        label: "العنوان",
        key: "title_ar",
      },
      {
        label: "تاريخ الانتهاء",
        key: "accomplished_at_date",
      },

      {
        label: "المحافظة",
        key: "governorate.name_ar",
      },

      {
        label: "المنظمة",
        key: "ngo.name_ar",
      },
    ],
    title: "أخبار المنظمة",
    queryObject: {
      query: {
        events: {
          data: {
            id: true,
            title_ar: true,
            accomplished_at_date: true,
            governorate: {
              name_ar: true,
            },
            ngo: {
              name_ar: true,
            },
          },
          paginatorInfo: PAGINATOR_INFO,
        },
      },
    },
    filtersObject: {
      "news.title_ar": {
        component: "FormInput",
        key: "news.title_ar",
        attrs: { label: "العنوان " },
      },
      "news.accomplished_at_date": {
        component: "FormMultiDatepicker",
        key: "news.accomplished_at_date",
        attrs: { label: "تاريخ الانتهاء " },
      },
      "news.governorate.ids": {
        component: "FormSelect",
        id: "news.governorate.ids",
        key: "news.governorate.ids",
        attrs: {
          ep: "v2/ministry/selects/graphql/governorates",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (المحافظة)",
        },
      },
      "news.ngo.ids": {
        component: "FormSelect",
        key: "news.ngo.ids",
        attrs: {
          id: "news.ngo.ids",
          ep: "v2/ministry/selects/graphql/ngos",
          reduce: DEFAULT_REDUCER,
          getOptionLabel: DEFAULT_LABEL,
          multiple: true,
          closeOnSelect: false,
          label: "المعرف (منظمة)",
        },
      },
    },
    breadcrumbs: [
      {
        text: "تقارير المنظمات",
        to: { name: "ngos-data" },
      },
      {
        text: "أخبار المنظمة",
        active: true,
      },
    ],
  },
  other: {
    fields: [
      { label: "نوع الآلية", key: "machineType", sortable: true },
      { label: "المحافظة", key: "governorate", sortable: true },
      { label: "صيغة التملك", key: "possessiveForm", sortable: true },
      { label: "نوع العقار", key: "estateType", sortable: true },
      { label: "تملك الضريبة؟", key: "tax", sortable: true },
    ],
  },
};
